import * as React from "react";
import Container from "@mui/material/Container/Container";
import Button from "@mui/material/Button/Button";
import {LangContext} from "../providers/LangProvider";
import Stack from "@mui/material/Stack/Stack";
import Badge from '@mui/material/Badge/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton/IconButton';
import Avatar from '@mui/material/Avatar/Avatar';
import {useNavigate, useLocation} from "react-router-dom";

import {AuthUserContext} from "../providers/AuthProvider";
import firebase, {logout} from "../firebase/firebase";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";



export default function TopBar({showBar}) {
  const {lang, setLang} = React.useContext(LangContext);
  const { user, profile, setProfile, setUser } = React.useContext(AuthUserContext);
  const match = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorNotificationEl, setAnchorNotificationEl] = React.useState(null);
  const [language, setLanguage] = React.useState(lang);
  const [showChatBadge, setChatBadge] = React.useState(true);
  const [showNotificationBadge, setNotificationBadge] = React.useState(true);
  const [notifications, setNotifications] = React.useState([]);
  const navigator = useNavigate()
  let projectPattern = /project/;
  const open = Boolean(anchorEl);
  const openNotification = Boolean(anchorNotificationEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const membershipPattren = /membership-plan|additional-details|projects-tags|geography-tags|membership-plan-payment|membership-payment/;


  if (


    /*  match.pathname === '/creator/additional-details'  || match.pathname === '/investor/additional-details'
        || match.pathname === '/investor/projects-tags'
        || match.pathname === '/investor/geography-tags'*/ match.pathname === '/auth/login'
    ||  match.pathname === '/auth/who-are-you'
    ||  match.pathname === '/auth/additional-details'
    ||  match.pathname === '/auth/about-your-work' ){

    showBar =false

  }

  const handleChange = (event) => {
    setLanguage(event.target.value);
  };

React.useEffect(() => {

  let unsubs;
  const messagesRef = firebase.firestore().collection('messages');
  if (profile) {
    unsubs =  messagesRef
      .limit(1)
      .where('receiver', '==', profile?.uid)
      .where('read', '==', false)
      .onSnapshot((data) => {

        setChatBadge(!(data?.size > 0))
      })
    return () => {
      unsubs()
    };
  }


}, []);
React.useEffect(() => {

  let unsubs;
  const notificationRef = firebase.firestore().collection('notifications').orderBy('createdAt', 'desc').limit(5);
  if (profile) {
    unsubs =  notificationRef
      .where(profile.userType !== 'admin' ? 'uid':'showing',
        profile.userType !== 'admin' ? '==':'array-contains'
        , profile.userType !== 'admin' ? profile?.uid : profile.super ? 'super' : 'admin')
      .where('read', '==', false)

      .onSnapshot((data) => {
        setNotificationBadge(!(data?.size > 0))
        if (data.size > 0){
          const list = []
          data.docs.forEach((d) => {
            list.push({...d.data(), id: d.id})
          });
          setNotifications(list);
        } else {setNotifications([])}
      })
    return () => {
      unsubs()
    };
  }


}, [profile]);
  return(
    <AppBar position="static" sx={{backgroundColor: '#fff', mb:0, boxShadow:'0px 2px 4px -1px rgb(0 0 0 / 4%), 0px 4px 5px 0px rgb(0 0 0 / 4%), 0px 1px 10px 0px rgb(0 0 0 / 4%)'}}>
      <Container maxWidth={profile?.userType === 'admin' ? 'full-width' : 'lg'} sx={{
        textAlign:'left',
        mt:4,
        mb:4
      }}>
        <Stack spacing={5} direction="row" sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {user ?
          <img src="/assets/logo-v2.png" onClick={()=> {
            console.log(profile.userType)
            navigator(`${profile?.userType === 'artist' ? 'artists/dashboard' : profile?.userType === 'admin' ? 'admin/user-analytics': profile?.userType+'/dashboard'}`)}}
               // navigator(`${profile?.userType !== 'artist' ? profile?.userType : 'artists'}/dashboard`)}}
               style={{height: 45, cursor:"pointer" }} alt="TAOST Logo "/>
          : 
          <img src="/assets/logo-v2.png" style={{height: 45 }} alt="Mogu Logo "/>
            }
          <div style={{flex: 1}}/>
          {showBar && showBar === true &&
          <>
            {profile?.userType !== 'admin' ? <>
              <Button
                sx={{ my: 2,  display: 'block', fontSize: 18, fontWeight:600, borderRadius:'0px', borderBottom:
                    match.pathname === '/investor/dashboard' || match.pathname === '/creator/dashboard' || match.pathname === '/artists/dashboard' ? '1.5px solid #204488': 'none', paddingX: '2px'}}
                onClick={() =>
                  profile?.userType && profile.userType === 'creator' ? navigator('/creator/dashboard'): profile.userType === 'artist' ?  navigator('/artists/dashboard') : navigator('/investor/dashboard')
                } disabled={membershipPattren.test(  match.pathname) === true}>Dashboard</Button>
              {/*pattern.test(projectText)*/}
              <Button
                disabled={membershipPattren.test(  match.pathname)}
                sx={{ my: 2,  display: 'block', fontSize: 18, fontWeight:600,  paddingX: '2px', borderRadius:'0px',
                borderBottom:match.pathname === '/creator/projects/list' ||match.pathname === '/artists/projects' ||match.pathname ==='/investor/projects' ? '1.5px solid #204488': 'none'
                }}
                onClick={() =>
                  profile?.userType && profile.userType === 'creator' ? navigator('/creator/projects/list'):profile.userType === 'artist' ?  navigator('/artists/projects'): navigator('/investor/projects')
                }>Projects</Button>

              {profile?.userType === 'creator' && <Button onClick={() => navigator('/creator/artists')}
                disabled={membershipPattren.test(  match.pathname)}
                sx={{ my: 2,  display: 'block', fontSize: 18, fontWeight:600,  paddingX: '2px', borderRadius:'0px', borderBottom:
                    match.pathname === '/creator/artists' ? '1.5px solid #204488': 'none' }}
              >Artists</Button>


              }

            </> : <>
              <Button
                sx={{ my: 2,  display: 'block', fontSize: 18, fontWeight:600, borderRadius:'0px', paddingX: '2px'}}
                onClick={() =>
                  navigator('/admin/user-analytics')
                }>Dashboard</Button>
            </>}










            {/* <Button
              disabled={membershipPattren.test(  match.pathname)}
              sx={{ my: 2,  display: 'block', fontSize: 18, fontWeight:600,  paddingX: '2px', borderRadius:'0px' }}
            >Artist</Button> */}
              <IconButton onClick={() => navigator(`/${profile?.userType !== 'artist' ? profile?.userType: 'artists' }/chat`)} disabled={membershipPattren.test(  match.pathname)}>
                <Badge color="warning" variant="dot" invisible={showChatBadge} >

                <img src={'/assets/icons/conversation.png'} style={{height: 30, width:30, mixBlendMode:membershipPattren.test(  match.pathname) ? 'luminosity': '', opacity: membershipPattren.test(  match.pathname) ? .4: 1 }} />            </Badge>

              </IconButton>


              <IconButton  id="basic-button-notification"
                           aria-controls="basic-menu-notification"
                           aria-haspopup="true"
                           aria-expanded={openNotification ? 'true' : undefined} onClick={(e) => notifications.length > 0 ? setAnchorNotificationEl(e.currentTarget) :navigator(`/${profile?.userType !== 'artist' ? profile?.userType: 'artists' }/notification-center`)}
              disabled={membershipPattren.test(  match.pathname)}
              >
                <Badge color="warning" variant="dot" invisible={showNotificationBadge}>
                <img src={'/assets/icons/bell.png'} style={{height: 30, width:30,mixBlendMode:membershipPattren.test(  match.pathname) ? 'luminosity': '', opacity: membershipPattren.test(  match.pathname) ? .4: 1 }} />
                </Badge>

              </IconButton>
            <Menu
              id="basic-menu-notification"
              anchorEl={anchorNotificationEl}
              open={openNotification}
              onClose={() => setAnchorNotificationEl(null)}
              MenuListProps={{
                'aria-labelledby': 'basic-button-notification',
              }}
            >
              {notifications.length > 0 && notifications.map((notification, i) =>(<ListItem key={i} alignItems="flex-start" button={true} onClick={() => {
                navigator(`/${profile?.userType !== 'artist' ? profile?.userType : 'artists'}/notification-center`);
                setAnchorNotificationEl(null)
              }} divider={(notifications[notifications.length -1].id !== notification.id)}>
                <ListItemText

                  primary={<Typography noWrap={true} sx={{maxWidth: 250, borderBottom: '1px solid', mb:2, pb: 2}} color={'primary'}>
                    {notification?.title}
                  </Typography>}
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{maxWidth: 250}}
                        paragraph={true}
                        variant="body2"
                        color="text.primary"
                      >
                        {notification?.text}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>))}

            </Menu>

          </>
          }

          {!user &&   (match.pathname === '/auth/login') ?  
          (<Button size={'medium'}
            sx={{ my: 2,  borderRadius:'0px', fontWeight:600, boxShadow: "0 1.25px 0 #204488"}} color={'primary'}>SIGN IN
          </Button>)
          : (match.pathname === '/auth/forgot-your-password-step1') &&
          <Button size={'medium'}
            sx={{ my: 2,  borderRadius:'0px', fontWeight:600, ":hover": {boxShadow: "0 1.25px 0 #204488"}}} color={'primary'} onClick={()=>navigator("/auth/login")}>SIGN IN
          </Button>}

          {!user ?<Button  size={'medium'}
                   sx={{ my: 2,  display: 'block', fontWeight:600, backgroundColor:'#FD4A01', py: 1, px:3 }} variant={'contained'} color={'warning'}
                   onClick={() => navigator(match.pathname === '/auth/login' || match.pathname === '/auth/forgot-your-password-step1'  ? '/auth/select-your-location' : '/auth/login')}>{match.pathname === '/auth/login' || match.pathname === '/auth/forgot-your-password-step1' ? 'Sign up': 'Sign in'} </Button>:
            profile && profile?.avatar ?
            <Button disabled={membershipPattren.test(  match.pathname)}><Avatar  src={profile?.avatar} alt={profile?.name} title={profile?.name} id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}>
              {profile?.name.charAt(0) }
            </Avatar></Button> :
            <Button disabled={membershipPattren.test(  match.pathname)}><Avatar  alt={profile?.name} title={profile?.name} sx={{backgroundColor: '#204488' }} id="basic-button"
                       aria-controls="basic-menu"
                       aria-haspopup="true"
                       aria-expanded={open ? 'true' : undefined}
                       onClick={handleClick}>
                {profile?.name.charAt(0).toUpperCase() }
              </Avatar></Button>

          }
          {profile?.userType !== 'admin' ?
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={() => {
              navigator(`${profile?.userType !== 'artist' ? profile?.userType : 'artists'}/profile`)
              handleClose()
            }}>Profile</MenuItem>
            <MenuItem onClick={() => {
              navigator(`${profile?.userType !== 'artist' ? profile?.userType : 'artists'}/settings`)
              handleClose()
            }}>Settings</MenuItem>
            <MenuItem onClick={() => {
              handleClose()
              setProfile(null)
              setUser(null)
              logout().then(() => {
                // navigator('/');
                // handleClose()
              })


            }}>Logout</MenuItem>
          </Menu> : 
          <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
            <MenuItem onClick={() => {
              navigator(`admin/settings`)
              handleClose()
            }}>Settings</MenuItem>
          <MenuItem onClick={() => {
            handleClose()
            setProfile(null)
            setUser(null)
            logout().then(() => {
              // navigator('/');
              // handleClose()
            })


          }}>Logout</MenuItem>
        </Menu>
}


        </Stack>
      </Container>

    </AppBar>

 )
}
